module.exports = __webpack_public_path__ + "img/title2-zh.b3eb948c.png";